import { saveAs } from 'file-saver';
import * as ExcelJS from 'exceljs/dist/exceljs.min.js';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const RUTA_API = "https://livefit.me/api/";
const MESES = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

const Utiles = {
    /**
     * @param {string} imagen - Nombre del archivo en la BD
     * @param {string} tipo - 'usuarios', 'miembros', 'productos', 'ajustes'
     */
    generarURL(imagen, tipo = 'usuarios') {
        if (!imagen) {
         
            switch (tipo) {
                case 'miembros': return RUTA_API + "fotos_miembros/usuario.png";
                case 'productos': return RUTA_API + "fotos_productos/default.png";
                case 'ajustes': return RUTA_API + "imagenes/logo.png";
                default: return RUTA_API + "fotos_usuarios/default.png";
            }
        }

       
        if (/^https?:\/\//.test(imagen)) return imagen;

 
        let limpio = imagen
            .replace(/^\.\/imagenes\//, '')
            .replace(/^imagenes\//, '')
            .replace(/^fotos_usuarios\//, '')
            .replace(/^fotos_miembros\//, '')
            .replace(/^fotos_productos\//, '')
            .replace(/^\.\/fotos_usuarios\//, '')
            .replace(/^\.\/fotos_miembros\//, '')
            .replace(/^\.\/fotos_productos\//, '')
            .replace(/^\.\/+/, '');

        
        const rutas = {
            'usuarios':  'fotos_usuarios/',
            'miembros':  'fotos_miembros/',
            'productos': 'fotos_productos/',
            'ajustes':   'imagenes/'
        };

        
        if (imagen.startsWith(rutas[tipo])) {
            return RUTA_API + imagen;
        }

        return RUTA_API + rutas[tipo] + limpio;
    },

    prepararGraficaSemanal(datosServidor, campoValor) {
        const mappingIngles = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
        const etiquetas = ["Lun", "Mar", "Mie", "Jue", "Vie", "Sab", "Dom"];
        const valores = [];
        const datosMap = {};
        (datosServidor || []).forEach(item => { datosMap[item.dia] = parseFloat(item[campoValor]) || 0; });
        mappingIngles.forEach(diaIngles => { valores.push(datosMap[diaIngles] || 0); });
        return { etiquetas, valores };
    },

    obtenerClaves(array) { return (array || []).map(elemento => elemento[Object.keys(elemento)[0]]); },
    obtenerValores(array) { return (array || []).map(elemento => parseInt(elemento.numeroVisitas) || 0); },
    obtenerValoresPagos(array) { return (array || []).map(elemento => parseFloat(elemento.total) || 0); },

    cambiarNumeroANombreMes(arreglo) {
        (arreglo || []).forEach(item => { if (item.mes) item.mes = MESES[item.mes - 1]; });
        return arreglo;
    },

    async exportarExcel(titulo, columnas, datos) {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Reporte');

       
        worksheet.columns = columnas.map(col => ({ header: col.text, key: col.value, width: 25 }));
        const headerRow = worksheet.getRow(1);
        headerRow.font = { bold: true, color: { argb: 'FFFFFF' } };
        headerRow.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '4318FF' } };
        headerRow.alignment = { vertical: 'middle', horizontal: 'center' };

      
        worksheet.addRows(datos);

      
        worksheet.eachRow((row, rowNumber) => {
            row.eachCell((cell) => {
                cell.alignment = { vertical: 'middle', horizontal: 'center' };
                cell.border = {
                    top: { style: 'thin' },
                    left: { style: 'thin' },
                    bottom: { style: 'thin' },
                    right: { style: 'thin' },
                };
            });
        });

       
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), `${titulo}.xlsx`);
    },

    exportarPDF(titulo, columnas, datos) {
        const doc = new jsPDF();
        doc.setFontSize(18);
        doc.setTextColor(27, 37, 89);
        doc.text(titulo, 14, 20);

        const tableColumn = columnas.map(c => c.text);
        const tableRows = (datos || []).map(d => columnas.map(c => {
            const v = d && Object.prototype.hasOwnProperty.call(d, c.value) ? d[c.value] : '';
            return v === null || v === undefined ? '' : String(v);
        }));

        doc.autoTable({
            head: [tableColumn],
            body: tableRows,
            startY: 30,
            headStyles: { fillColor: [67, 24, 255], textColor: [255, 255, 255], fontSize: 12 },
            bodyStyles: { fontSize: 10, textColor: [0, 0, 0] },
            alternateRowStyles: { fillColor: [240, 240, 240] },
            theme: 'striped',
            margin: { top: 20, left: 10, right: 10 },
        });

        doc.save(`${titulo}.pdf`);
    }
}

export default Utiles;


// WEBPACK FOOTER //
// ./src/Servicios/Utiles.js